<template>
  <div>
    <div class="hamburger" @click="mobileNav">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </div>
    <nav class="main_nav">
      <h1 class="logo"><router-link to="/">Marché Human Way</router-link></h1>
      <ul class="nav-links">
        <!-- <li class="header"><router-link to="/">Problématique</router-link></li>
        <li>
          <router-link to="/Produits">Solution</router-link>
        </li>
        <li>
          <router-link to="/Produits">Producteurs</router-link>
        </li>
        <li>
          <router-link to="/Produits">Produits</router-link>
        </li>
        <li>
          <router-link to="/Produits">Livraison</router-link>
        </li>
        <li>
          <router-link to="/Produits">Contact</router-link>
        </li>
        <li>
          <router-link to="/Produits">Recette</router-link>
        </li> -->
      </ul>
    </nav>
    <nav class="mobile_nav" v-if="displayNav">
      <ul class="nav-links">
        <li><router-link to="/" @click="mobileNav">Accueil</router-link></li>
        <li>
          <!-- <router-link to="/Produits" @click="mobileNav">Produits</router-link> -->
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "navbar",
  components: {},
  data() {
    return {
      displayNav: false
    };
  },
  methods: {
    mobileNav() {
      this.displayNav = !this.displayNav;
    }
  },
  computed: {}
};
</script>

<style scoped>
.logo {
  font-family: "Raleway", sans-serif;
  font-size: 18px;
}

a {
  color: #aaa;
  margin: 0;
  padding: 0;
  border: 0;
  font-family: "Raleway", sans-serif;
  text-decoration: none;
}

.main_nav {
  width: 92%;
  position: sticky;
  margin: auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  z-index: 100;
  padding: 1rem 0;
}

.mobile_nav {
  /* display: none; */
  width: 92%;
  position: absolute;
  top: 3%;
  right: 3%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
}

.nav-links {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

li {
  margin: 0 2rem;
}

@media screen and (max-width: 768px) {
  .line {
    width: 30px;
    height: 3px;
    background: #fff;
    margin: 5px;
  }

  .main_nav {
    display: none;
  }

  .mobile_nav {
    flex-wrap: wrap;
    justify-content: right;
    width: 100%;
    margin: 0;
    right: 0;
    top: 0;
  }

  .hamburger {
    position: absolute;
    /* top: 2%;
        right: 2%; */
    cursor: pointer;
    padding-top: 1rem;
    z-index: 3;
  }

  .nav-links {
    /* position: fixed; */
    background: rgba(0, 0, 0, 0.8);
    min-height: 100vh;
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 50px;
  }

  li {
    margin: 2rem 0;
  }
}

h2 {
  color: #686262;
  display: inline-block;
  font-size: 3.5em;
  line-height: 1.35;
  margin-bottom: 0.5em;
}

p {
  margin: 0 0 2em 0;
}
</style>
